module.exports = __webpack_public_path__ + "prod/1.42.2/img/42.b7aff556.svg";